import React from "react";
import Navbar from "../component/Navbar";

import Footer from "../component/Footer";
import Webimagefooter from "../component/Webimagefooter";
import ContactSection from "../component/ContactSection";
import Putfirst from "../component/About/Putfirst";
import Calltoaction from "../component/Calltoaction";
import FAQSection from "../component/FAQSection";
import BlogPreview from "../component/BlogPreview";

const Contactus = () => {
  return (
    <div className="w-full bg-[#00001A]">
      <Navbar />
      <ContactSection />
      <Putfirst />
      <Calltoaction/>
      <FAQSection/>
      <BlogPreview/>
      <Footer />

    </div>
  );
};

export default Contactus;
